var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48113 0H39.5189V4.98113H5.48113V0Z",
    fill: "#65ECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48113 39.0189H0.5L0.500002 4.98113H5.48113V39.0189Z",
    fill: "#65ECEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5189 39.0189V44H5.48113V39.0189H39.5189Z",
    fill: "#65ECEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5189 39.0189H44.5V4.98113H39.5189V39.0189Z",
    fill: "#65ECEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4623 16.8517L30.9115 13.3584L20.8673 23.5682L16.5791 19.2093L13.0282 22.7026L19.0919 28.8661C19.56 29.342 20.1997 29.6101 20.8673 29.6101C21.5349 29.6101 22.1745 29.342 22.6427 28.8661L34.4623 16.8517Z",
    fill: "#65ECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5e4bd63a1fd48340651c550609202e34.svg";
export { ForwardRef as ReactComponent };